<template>
  <div class="append-box">
    <template v-if="orien == 'horizontal'">
      <v-mask
        style="background: rgba(0, 0, 0, 0.8)"
        @touchmove="gtouchmove"
      ></v-mask>
      <div class="dialog-notice-box">
        <div
          v-bind:class="{
            'animated baisonFadeIn ani-dialog-notice-box': true,
            baisonFadeOut: fadeOut,
          }"
        >
          <swiper ref="swiperComponent" :options="swiperOptions">
            <swiper-slide
              v-for="(item, index) in helpData"
              v-bind:key="index"
              class="swiper-item"
            >
              <img :src="imgHost + item.content" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div
        v-bind:class="{
          'animated baisonFadeIn op-box': true,
          baisonFadeOut: fadeOut,
        }"
      >
        <div class="slot-list">
          <div
            class="slot-item"
            v-for="(item, index) in helpData"
            v-bind:key="index"
          >
            <img
              src="@/assets/img/help/swiper/img_point_check.png"
              v-bind:class="{ selected: selectedIndex == index }"
              v-if="selectedIndex == index"
            />
            <img src="@/assets/img/help/swiper/img_point_def.png" v-else />
          </div>
        </div>
        <div class="btn-box">
          <div class="btn-item">
            <btn class="btn-pre" text @click="handleSwiperPre"></btn>
          </div>
          <div class="btn-item">
            <btn class="btn-goon" text @click="handleClose"></btn>
          </div>
          <div class="btn-item">
            <btn class="btn-next" text @click="handleSwiperNext"></btn>
          </div>
        </div>
      </div>
    </template>
    <template v-if="orien == 'vertical'">
      <v-mask
        style="background: rgba(0, 0, 0, 0.8)"
        @touchmove="gtouchmove"
      ></v-mask>
      <div class="dialog-notice-box-vertical">
        <div
          v-bind:class="{
            'animated baisonFadeIn ani-dialog-notice-box': true,
            baisonFadeOut: fadeOut,
          }"
        >
          <swiper ref="swiperComponent" :options="swiperOptions">
            <swiper-slide
              v-for="(item, index) in helpData"
              v-bind:key="index"
              class="swiper-item"
            >
              <img :src="imgHost + item.content" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div
        v-bind:class="{
          'animated baisonFadeIn op-box-vertical': true,
          baisonFadeOut: fadeOut,
        }"
      >
        <div class="btn-box">
          <div class="btn-item">
            <btn class="btn-pre" text @click="handleSwiperPre"></btn>
          </div>
          <div class="btn-item">
            <btn class="btn-goon" text @click="handleClose"></btn>
          </div>
          <div class="btn-item">
            <btn class="btn-next" text @click="handleSwiperNext"></btn>
          </div>
        </div>
        <div class="slot-list">
          <div
            class="slot-item"
            v-for="(item, index) in helpData"
            v-bind:key="index"
          >
            <div class="img-box">
              <img
                src="@/assets/img/help/swiper/img_point_check.png"
                v-bind:class="{ selected: selectedIndex == index }"
                v-if="selectedIndex == index"
              />
              <img src="@/assets/img/help/swiper/img_point_def.png" v-else />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import btn from "@/components/btn.vue";
import store from "@/store/index";
import { getHelpInfo } from "@/api/task";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
export default {
  name: "dialogHelpSwiper",
  components: {
    "v-mask": vmask,
    btn,
    Swiper,
    SwiperSlide,
  },
  computed: {
    closeAllPopUp() {
      return store.state.app.closeAllPopUp;
    },
    sizeDeirection() {
      return store.state.app.sizeDeirection;
    },
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      imgHost: "https://" + store.state.app.domain.replace("gw.", "task."),
      theme: store.state.app.theme,
      orien: store.state.app.sizeDeirection,
      lang: "cn",
      fadeOut: false,
      tabMenuIndex: 1,
      gameId: 0,
      style: 1,
      selectedIndex: 0,
      helpData: [],
      swiperOptions: {
        loop: false,
        on: {
          slideChangeTransitionEnd: function (cb) {
            this.selectedIndex = cb.realIndex;
          }.bind(this),
        },
      },
    };
  },
  watch: {
    closeAllPopUp(val) {
      if (val.key != "dialogHelp") {
        this.remove();
      }
    },
    sizeDeirection(orien) {
      this.orien = orien;
      this.changeDirection();
    },
  },
  mounted() {
    store.dispatch("setCloseAllPopUp", "dialogHelp");
    getHelpInfo(this.gameId, this.lang).then((res) => {
      res = res.data;
      if (res.code == 0) {
        if (res.result.data && res.result.data.length > 0) {
          this.helpData = res.result.data;
        }
      }
    });
    this.changeDirection();
  },
  filters: {
    filterTitle: function (value) {
      if (!value) return "";
      if (String(value).length > 4) {
        return String(value).substr(0, 4);
      } else {
        return value;
      }
    },
  },
  methods: {
    changeDirection() {
      const _direction = this.orien == "horizontal" ? "horizontal" : "vertical";
      this.$refs.swiperComponent.$swiper.changeDirection(_direction);
    },
    handleSwiperPre() {
      this.$refs.swiperComponent.$swiper.slidePrev();
    },
    handleSwiperNext() {
      this.$refs.swiperComponent.$swiper.slideNext();
    },
    resetItem() {
      this.item = {
        type: 1,
        title: "",
        content: "",
      };
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    remove() {
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
      window.__dialogHelp = null;
    },
    handleClose() {
      this.fadeOut = true;
      setTimeout(() => {
        this.remove();
        this.fadeOut = false;
        window.__dialogNotice = null;
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 88889;
  .dialog-notice-box {
    font-family: Microsoft YaHei;
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    z-index: 301;
    color: #ffffff;
    height: 3.6rem;
    width: 100%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    .ani-dialog-notice-box {
      width: 100%;
      height: 100%;
      background-size: cover;
      font-size: 0.12rem;
      position: relative;
    }
    .swiper-container {
      height: 3rem;
      width: 100%;
    }
    .swiper-item {
      text-align: center;
      text-align: center;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      img {
        height: 100%;
      }
    }
  }
  .op-box {
    position: absolute;
    z-index: 302;
    left: 50%;
    top: 50%;
    margin-top: 1.5rem;
    transform: translate(-50%, -50%) scale(0.75);
    .slot-list {
      display: table;
      height: 0.11rem;
      margin: 0 auto;
      .slot-item {
        display: table-cell;
        vertical-align: middle;
        height: 0.11rem;
        width: 0.11rem;
        line-height: 0.11rem;
        padding: 0 0.05rem;
        img {
          width: 0.07rem;
          height: 0.07rem;
          float: left;
          margin-top: 0.1rem;
          &.selected {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .btn-box {
      height: 0.55rem;
      display: table;
      margin-top: 0.05rem;
      .btn-item {
        display: table-cell;
        vertical-align: middle;
        padding: 0 0.05rem;
        .btn-pre {
          width: 0.51rem;
          height: 0.48rem;
          background: url(~@/assets/img/help/swiper/img_pre.png) no-repeat;
          background-size: cover;
        }
        .btn-next {
          width: 0.51rem;
          height: 0.48rem;
          background: url(~@/assets/img/help/swiper/img_next.png) no-repeat;
          background-size: cover;
        }
        .btn-goon {
          width: 2.415rem;
          height: 0.55rem;
          background: url(~@/assets/img/help/swiper/btn_goon.png) no-repeat;
          background-size: cover;
        }
      }
    }
  }
  .dialog-notice-box-vertical {
    font-family: Microsoft YaHei;
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    z-index: 301;
    color: #ffffff;
    width: 3.6rem;
    height: 100%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    .ani-dialog-notice-box {
      width: 100%;
      height: 100%;
      background-size: cover;
      font-size: 0.12rem;
      position: relative;
    }
    .swiper-container {
      height: 100%;
      width: 4.5rem;
    }
    .swiper-item {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      transform: rotate(90deg);
      img {
        width: 100%;
      }
    }
  }
  .op-box-vertical {
    position: absolute;
    z-index: 302;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0.75);
    margin-left: -1.2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    .slot-list {
      display: flex;
      flex-direction: column;
      width: 0.2rem;
      margin-top: 1.4rem;
      .slot-item {
        width: 0.2rem;
        text-align: center;
        margin: 0 auto;
        height: 0.3rem;
        .img-box {
          display: flex;
          align-items: center;
          img {
            width: 0.1rem;
            height: 0.1rem;
            margin: 0 auto;
            &.selected {
              width: 0.15rem;
              height: 0.15rem;
            }
          }
        }
      }
    }
    .btn-box {
      display: flex;
      flex-direction: column;
      .btn-item {
        padding: 0.05rem 0;
        .btn-pre {
          height: 0.51rem;
          width: 0.48rem;
          background: url(~@/assets/img/help/swiper/vertical/img_pre.png)
            no-repeat;
          background-size: cover;
        }
        .btn-next {
          height: 0.51rem;
          width: 0.48rem;
          background: url(~@/assets/img/help/swiper/vertical/img_next.png)
            no-repeat;
          background-size: cover;
        }
        .btn-goon {
          height: 2.415rem;
          width: 0.55rem;
          background: url(~@/assets/img/help/swiper/vertical/btn_goon.png)
            no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>